export const PUBLIC_ORGANIZATION_ID = '__PUBLIC__ORGANIZATION__';
export const ADMIN_ORGANIZATION_ID = '__ADMIN__ORGANIZATION__';
